import React from 'react';
import cn from 'classnames';
import { CopyBtn } from '@views/Settings/panels/Integrations/panels/CardDav';
import styles from './CopySourceBtn.module.scss';

export default function CopySourceBtn({
  value,
  className,
  copiedClassName,
}: {
  value: string;
  className?: string;
  copiedClassName?: string;
}) {
  return (
    <CopyBtn
      label=""
      value={value}
      className={cn(styles.copyBtn, className)}
      copiedClassName={cn(styles.copied, copiedClassName)}
    />
  );
}
